import { Box, Heading, Loader } from '@hover/blueprint';
import { defaultLocalStorageAdapter } from '@hover/graphql';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';

import { config } from 'src/config';

const Logout = () => {
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  useEffect(() => {
    const logout = async () => {
      try {
        const response = await fetch(`${config.API_URI}/sessions`, {
          method: 'DELETE',
          credentials: 'include',
        });

        if (!response.ok) throw new Error(response.statusText);

        setIsLoggedOut(true);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('An error occurred attempting to logout via API', error);
      }
    };

    void defaultLocalStorageAdapter.removeAccessToken();
    void defaultLocalStorageAdapter.removeRefreshToken();

    void logout();
  }, []);

  return isLoggedOut ? (
    <Redirect to="/" />
  ) : (
    <Box
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      marginTop={500}
    >
      <Loader size="huge" />
      <Heading marginBottom={700} size={500}>
        Logging out...
      </Heading>
    </Box>
  );
};

export { Logout };
